import script from "./Team.vue?vue&type=script&setup=true&lang=js"
export * from "./Team.vue?vue&type=script&setup=true&lang=js"

import "./Team.vue?vue&type=style&index=0&id=1a679634&lang=less&scoped=true"
script.__scopeId = "data-v-1a679634"

export default script